import React, { FC } from 'react';
import classNames from 'classnames/bind';
import Link from 'next/link';
import styles from 'sections/Resources/FreightDictionary/landing/SectionRelatedTerms/SectionRelatedTerms.module.scss';

const cn = classNames.bind(styles);

type SectionRelatedTermsProps = {
  relatedTerms: {
    url: string;
    name: string;
  }[]
}

const SectionRelatedTerms: FC<SectionRelatedTermsProps> = ({ relatedTerms }) => {
  return (
    <section className={cn('related-terms')}>
      <div className={cn('container')}>
        <h3 className={cn('related-terms__heading')}>
          Related Terminologies
        </h3>
        <ul className={cn('related-terms__list')}>
          {relatedTerms.map(({ name, url }, idx) => (
            <li key={idx} className={cn('related-terms__list-item')}>
              <Link
                className={cn('related-terms__list-item-link')}
                href={`/freight-dictionary/${url}`}
              >
                <span>{name}</span>
                <svg viewBox="0 0 10 10" aria-hidden="true">
                  <path d="M1 5h7" />
                  <path d="M2 1l4 4-4 4" />
                </svg>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default SectionRelatedTerms;
